export default __webpack_public_path__ + "static/media/55.82f20d3b.jpg";